export default {
  'menu.welcome': 'Welcome',
  'menu.home': 'Home',
  'menu.login': 'Login',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.account.logout': 'Logout',
  'menu.workbench': 'Workbench',
  'menu.workbench.finance-report': 'Finance Overview',
  'menu.workbench.todo': 'My Todo',
  'menu.project-center': 'Project Management',
  'menu.project-center.project': 'Project List',
  'menu.project-center.board': 'Project Board',
  'menu.project-center.quotation': 'Quotation',
  'menu.finance': 'Finance Management',
  'menu.finance.receivable': 'Receivable',
  'menu.finance.payment': 'Payment Records',
  'menu.finance.bill': 'Bill Management',
  'menu.project': 'Project List',
  'menu.quotation': 'Quotation',
  'menu.receivable': 'Receivable',
  'menu.payment': 'Payment Records',
  'menu.bill': 'Bill Management',
  'menu.finance-report': 'Finance Overview',
  'menu.board': 'Project Board',
  'menu.todo': 'My Todo',
};
